import React from "react";
import { useTranslation } from "react-i18next";
import { QueriesAndValidationsValidationSignedDocumentView } from "../../views";
import { LocalStorageService, RequestService } from "../../../services";

class QueriesAndValidationsValidationSignedDocumentAction extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filePdf: null,
      fileAsn1CM: null,
      fileAsn1ST: null,
      filePdfBase64: "",
      targetFiles: null,

      showPdfFounded: false,
      showAsn1CMFounded: false,
      showAsn1STFounded: false,
      showValidationResults: false,
      showValidationButton: false,

      serviceListPsc: "",
      validationPdfResult: {
        id: "",
        messageValid: "",
        documentName: "",
        requestName: "",
        requestDescription: "",
        requestEndDate: "",
        requestSignatureType: "",
      },
      validationAsn1CMResult: {
        messageValid: "",
        documentName: "",
      },
      validationAsn1STResult: {
        messageValid: "",
        documentName: "",
      },
      dataItem: {
        id: "",
        name: "",
      },
      contractUserExist: true,
      loading: false,
      errorMessageList: [
        { id: 0, showError: false, message: "" }, // Error .pdf provided not valid
        { id: 1, showError: false, message: "" }, // Error .asn1 CM provided not valid
        { id: 2, showError: false, message: "" }, // Error .asn1 ST provided not valid
      ],
      message: "",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
    };
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService();
  requestService = new RequestService(this.url);
  initialState = {};

  /**
   * @author Alan Aguilar
   * @description Method ComponentDidMount to upload initial information in state
   * @updatedDate 25-11-2021
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  async componentDidMount() {
    this.initialState = this.state;
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let contractUserExistFlag =
      this.localStorageService.getLocalStorageItem("contractUserExist");
    let contactExist =
      contractUserExistFlag &&
        contractUserExistFlag.data?.userHadContracts &&
        contractUserExistFlag.data?.userHadContracts !== ""
        ? contractUserExistFlag.data?.userHadContracts
        : true;
    this.setState({ contractUserExist: contactExist });
    this.setState({ loading: false });
  }

  /**
   * @author Alan Aguilar
   * @description Functon to move the scroll to the top of window
   * @updatedDate 25-11-2021
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  scrollWindow = () => {
    window.scrollTo(0, 0);
  };

  /**
   * @author Alan Aguilar
   * @description Function to show or hide the LoadingRequesting Dialog
   * @updatedDate 25-11-2021
   * @param {Boolean} value
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({ showLoadingRequesting: value });
  };

  /**
   * @author Alan Aguilar
   * @description Function to show or hide the CompletedRequesting Dialog
   * @updatedDate 25-11-2021
   * @param {Boolean} value
   * @param {Boolean} redirect
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  toggleCompletedRequesting = (value, redirect) => {
    this.setState(
      {
        showCompletedRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showCompletedRequesting: false });
          if (redirect === true) this.props.history.push("/");
        }, 3000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Function to show or hide the ErrorRequesting Dialog
   * @updatedDate 25-11-2021
   * @param {Boolean} value
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  toggleErrorRequesting = (value) => {
    this.setState(
      {
        showErrorRequesting: value,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false });
        }, 4000);
      }
    );
  };

  /**
   * @author Alan Aguilar
   * @description Function to obtain the base64 of a Buffer object from a Pdf
   * @updatedDate 25-11-2021
   * @param {Buffer} file
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  pdfToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  /**
   * @author Alan Aguilar
   * @description Function to clear and assign the initial values component in the state
   * @updatedDate 25-11-2021
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onClearToNewReport = async () => {
    this.scrollWindow();
    await this.toggleLoadingRequesting(true);

    let state = { ...this.state };
    state = this.initialState;
    this.setState(state);

    await this.toggleLoadingRequesting(false);
    return true;
  };

  /**
   * @author Alan Aguilar
   * @description Function to delete a file in state and hide the rest of the information
   * @updatedDate 25-11-2021
   * @param {String} fileType
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onDeleteFile = (fileType) => {
    switch (fileType) {
      case "document_pdf":
        this.setState({
          filePdf: null,
          filePdfBase64: "",
          showPdfFounded: false,
          fileAsn1CM: null,
          showAsn1CMFounded: false,
          fileAsn1ST: null,
          showAsn1STFounded: false,
        });
        break;

      case "cm_asn1":
        this.setState({
          fileAsn1CM: null,
        });
        break;

      case "st_asn1":
        this.setState({
          fileAsn1ST: null,
        });
        break;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Function to show or hide labels of array errors in state
   * @updatedDate 25-11-2021
   * @param {Number} id
   * @param {Boolean} showError
   * @param {String} message
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onShowLabelError = (id, showError, message) => {
    let state = this.state;
    let tempState = null;

    for (let i = 0; i < state.errorMessageList.length; i++) {
      if (state.errorMessageList[i].id === id) {
        tempState = [...state.errorMessageList];
        let tempElement = { ...state.errorMessageList[i] };
        tempElement.showError = showError === true ? true : false;
        tempElement.message =
          showError === true && message !== "" ? message : "";
        tempState[i] = tempElement;
        break;
      }
    }

    if (tempState) this.setState({ errorMessageList: tempState });
  };

  /**
   * @author Alan Aguilar
   * @description Function to save a file provided in the state
   * @updatedDate 08-12-2021
   * @param {Object} e
   * @param {String} fileType
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onSaveFile = async (e, fileType) => {
    if (!e.target.files || e.target.files.length <= 0) return false;

    let extnArray = e.target.files[0].name.split(".");
    let extn = extnArray[extnArray.length - 1].toLowerCase();

    // eslint-disable-next-line default-case
    switch (fileType) {
      case "document_pdf":
        let extnValid1 = extn === "pdf" ? true : false;
        let messageError1 =
          extn === "pdf"
            ? ""
            : `${this.props.t(
              "validationSignedDocumentsAction.messageErrorFilePdf"
            )}`;

        this.onShowLabelError(0, !extnValid1, messageError1);
        if (extnValid1 === false) return false;

        let pdfBase64 = "";
        let targetFiles;
        if (e.target.files.length > 0) {
          let fileBase64 = await this.pdfToBase64(e.target.files[0]);
          pdfBase64 = fileBase64.split(",")[1];
          targetFiles = e.target.files[0];
        }

        // await this.onSearchDocumentPdf(e.target.files[0]);

        this.setState({
          filePdfBase64: pdfBase64,
          showPdfFounded: true,
          filePdf: fileType,
          targetFiles: targetFiles,
        });
        break;

      case "cm_asn1":
        let extnValid2 = extn === "asn1" ? true : false;
        let messageError2 =
          extn === "asn1"
            ? ""
            : `${this.props.t(
              "validationSignedDocumentsAction.messageErrorFileAsn1CM"
            )}`;

        this.onShowLabelError(1, !extnValid2, messageError2);
        if (extnValid2 === false) return false;

        this.setState({
          fileAsn1CM: extnValid2 === true ? e.target.files[0] : null,
          showAsn1CMFounded: extnValid2 === true ? true : false,
        });
        break;

      case "st_asn1":
        let extnValid3 = extn === "asn1" ? true : false;
        let messageError3 =
          extn === "asn1"
            ? ""
            : `${this.props.t(
              "validationSignedDocumentsAction.messageErrorFileAsn1ST"
            )}`;

        this.onShowLabelError(2, !extnValid3, messageError3);
        if (extnValid3 === false) return false;

        this.setState({
          fileAsn1ST: extnValid3 === true ? e.target.files[0] : null,
          showAsn1STFounded: extnValid3 === true ? true : false,
        });
        break;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Function to search the signature request information by Pdf document provided
   * @updatedDate 25-11-2021
   * @param {Buffer} filePdfProvided
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onSearchDocumentPdf = async (filePdfProvided) => {
    let result = null;
    let backendStatusCode = 0;
    try {
      await this.toggleLoadingRequesting(true);

      let bodyFiles = new FormData();
      bodyFiles.append("filePdf", filePdfProvided);

      const resultSearchDocumentPdf =
        await this.requestService.searchDocumentPdf(bodyFiles, this.token);
      if (
        resultSearchDocumentPdf.data &&
        resultSearchDocumentPdf.statusCode === 200
      ) {
        result = resultSearchDocumentPdf.data;
      } else {
        backendStatusCode = Number(resultSearchDocumentPdf.statusCode);
        throw new Error();
      }

      let serviceListPscText = "";
      let serviceCMisRequired = false;
      let serviceSTisRequired = false;

      if (!result.servicesList.length) {
        this.onValidRequestDocuments();
      } else {
        for (let i = 0; i < result.servicesList.length; i++) {
          if (result.servicesList[i].serviceId === 2) {
            serviceCMisRequired = true;
            serviceListPscText += `${this.props.t(
              "validationSignedDocumentsAction.serviceListCM"
            )}`;
            if (result.servicesList.length > 1 && i === 0)
              serviceListPscText += ` ${this.props.t(
                "validationSignedDocumentsAction.And"
              )} `;
          } else if (result.servicesList[i].serviceId === 1) {
            serviceSTisRequired = true;
            serviceListPscText += `${this.props.t(
              "validationSignedDocumentsAction.serviceListST"
            )}`;
            if (result.servicesList.length > 1 && i === 0)
              serviceListPscText += ` ${this.props.t(
                "validationSignedDocumentsAction.And"
              )} `;
          }
        }
      }

      this.setState({
        serviceListPsc: serviceListPscText,
        showAsn1CMFounded: serviceCMisRequired,
        showAsn1STFounded: serviceSTisRequired,
        showValidationButton: true,
      });

      if (result.servicesList.length) {
        await this.toggleLoadingRequesting(false);
      }
      await this.toggleCompletedRequesting(false, false);
      return true;
    } catch (error) {
      switch (backendStatusCode) {
        case -420:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchInvalidPdf"
            )}`,
          });
          break;
        case 403:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchForbidden"
            )}`,
          });
          break;
        case -2:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchPdfNotFounded"
            )}`,
          });
          break;
        default:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchDefault"
            )}`,
          });
      }
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Function to create a new request "Validation Report Document"
   * @updatedDate 25-11-2021
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onValidRequestDocuments = async () => {
    let result = null;
    let backendStatusCode = 0;
    this.scrollWindow();

    try {
      await this.toggleLoadingRequesting(true);
      let { targetFiles, fileAsn1CM, fileAsn1ST } = this.state;

      let bodyFiles = new FormData();
      bodyFiles.append("filePdf", targetFiles);
      bodyFiles.append("fileCMAsn1", fileAsn1CM ? fileAsn1CM : null);
      bodyFiles.append("fileSTAsn1", fileAsn1ST ? fileAsn1ST : null);

      const resultValidateDocuments =
        await this.requestService.createRequestValidationReport(
          bodyFiles,
          this.token
        );
      if (
        resultValidateDocuments.data &&
        resultValidateDocuments.statusCode === 200
      ) {
        result = resultValidateDocuments.data;
      } else {
        backendStatusCode = Number(resultValidateDocuments.statusCode);
        throw new Error();
      }

      let dataItemFile = {
        id: "",
        name: "",
      };

      let validationPdfResult = { ...this.state.validationPdfResult };
      let validationAsn1CMResult = { ...this.state.validationAsn1CMResult };
      let validationAsn1STResult = { ...this.state.validationAsn1STResult };
      validationPdfResult.id = result.requestResult.id;
      validationPdfResult.messageValid = result.resultPDFValidated.validationOK
        ? `${this.props.t("validationSignedDocumentsAction.leyendValid")}`
        : "";
      validationPdfResult.documentName = result.resultPDFValidated.documentName;
      validationPdfResult.requestName =
        result.resultPDFValidated.signRequest.name;
      validationPdfResult.requestDescription =
        result.resultPDFValidated.signRequest.description;
      validationPdfResult.requestEndDate = result.requestResult.endDate;
      validationPdfResult.hash =
        result.resultPDFValidated.signRequest.finalHash;

      let signatureTypeIdFromValidateDocuments = 0;

      const workflowOrSolitudeName = result.requestResult.inboxTypeId < 4 ? 'solicitudeId' : 'workflowExecutionId'

      dataItemFile.name = result.resultPDFValidated.signRequest.name;
      dataItemFile.id = result.resultPDFValidated.signRequest.id;
      dataItemFile.contactExistFlag = this.state.contractUserExist;
      dataItemFile.inboxTypeId = result.requestResult.inboxTypeId
      dataItemFile[workflowOrSolitudeName] = result.requestResult[workflowOrSolitudeName]

      this.setState({
        dataItem: dataItemFile,
      });

      if (
        Number(result.resultPDFValidated.signRequest.signatureTypeId) ===
        Number(process.env.REACT_APP_SIGNATURE_TYPE_E_FIRMA)
      ) {
        signatureTypeIdFromValidateDocuments = `${this.props.t(
          "validationSignedDocumentsAction.leyendEsign"
        )}`;
      } else if (
        Number(result.resultPDFValidated.signRequest.signatureTypeId) ===
        Number(process.env.REACT_APP_SIGNATURE_TYPE_ELECTRONICA)
      ) {
        signatureTypeIdFromValidateDocuments = `${this.props.t(
          "validationSignedDocumentsAction.leyendAdvanceSign"
        )}`;
      } else if (
        Number(result.resultPDFValidated.signRequest.signatureTypeId) ===
        Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA)
      ) {
        signatureTypeIdFromValidateDocuments = `${this.props.t(
          "validationSignedDocumentsAction.leyendAutographySign"
        )}`;
      }
      validationPdfResult.requestSignatureType =
        signatureTypeIdFromValidateDocuments;

      // if (result.resultPDFValidated.signRequest.finalHash){
      // validationPdfResult.hash = result.signRequest.finalHash
      // }
      if (result.resultASN1CMValidated?.validationOK) {
        validationAsn1CMResult.messageValid = result.resultASN1CMValidated
          .validationOK
          ? `${this.props.t("validationSignedDocumentsAction.leyendValid")}`
          : "";
        validationAsn1CMResult.documentName =
          result.resultASN1CMValidated.documentName;
      }

      if (result.resultASN1STValidated?.validationOK) {
        validationAsn1STResult.messageValid = result.resultASN1STValidated
          .validationOK
          ? `${this.props.t("validationSignedDocumentsAction.leyendValid")}`
          : "";
        validationAsn1STResult.documentName =
          result.resultASN1STValidated.documentName;
      }

      this.setState({
        validationPdfResult,
        validationAsn1CMResult,
        validationAsn1STResult,
        showValidationResults: true,
      });

      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, false);
      return true;
    } catch (error) {
      switch (backendStatusCode) {
        case -420:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchInvalidPdf"
            )}`,
          });
          break;
        case 403:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchForbidden"
            )}`,
          });
          break;
        default:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchDefault"
            )}`,
          });
      }
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  /**
   * @author Alan Aguilar
   * @description Function to send the email to user requesting with the "Validation Report Document" created
   * @updatedDate 25-11-2021
   * @memberof QueriesAndValidationsValidationSignedDocumentAction
   */
  onCloseAndSendValidationReport = async () => {
    let backendStatusCode = 0;
    this.scrollWindow();

    try {
      await this.toggleLoadingRequesting(true);

      let requestId = this.state.validationPdfResult.id;
      const sendReportValidation =
        await this.requestService.sendEmailRequestValidationReport(
          requestId,
          this.token
        );
      if (!sendReportValidation.statusCode === 200) {
        backendStatusCode = Number(sendReportValidation.statusCode);
        throw new Error();
      }

      await this.toggleLoadingRequesting(false);
      await this.toggleCompletedRequesting(true, true);
      return true;
    } catch (error) {
      switch (backendStatusCode) {
        case -420:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchInvalidPdf"
            )}`,
          });
          break;
        case 403:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchForbidden"
            )}`,
          });
          break;
        default:
          this.setState({
            message: `${this.props.t(
              "validationSignedDocumentsAction.messageErrorCatchDefault"
            )}`,
          });
      }
      await this.toggleLoadingRequesting(false);
      await this.toggleErrorRequesting(true);
      return false;
    }
  };

  render() {
    return (
      <QueriesAndValidationsValidationSignedDocumentView
        {...this.state}
        scrollWindow={this.scrollWindow}
        onSaveFile={this.onSaveFile}
        onDeleteFile={this.onDeleteFile}
        onValidRequestDocuments={this.onValidRequestDocuments}
        onCloseAndSendValidationReport={this.onCloseAndSendValidationReport}
        onClearToNewReport={this.onClearToNewReport}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        onSearchDocumentPdf={this.onSearchDocumentPdf}
      />
    );
  }
}

function QueriesAndValidationsValidationSignedDocumentViewContainer(props) {
  const { t } = useTranslation();
  return (
    <QueriesAndValidationsValidationSignedDocumentAction {...props} t={t} />
  );
}
export { QueriesAndValidationsValidationSignedDocumentViewContainer as default };
